import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, InputGroup } from '@blueprintjs/core'

export default (props) => {

    const [filter, setFilter] = useState('');

    return (
        <>
            <InputGroup
                large
                placeholder={'Filter'}
                leftIcon={'search'}
                onChange={(e) => {
                    setFilter(e.target.value)
                }}
            />
            <Menu style={{
                maxHeight: '75vh',
                overflow: 'auto'
            }}>
                {props.languages.filter((language) => (filter.length == 0 || language.name.toLowerCase().indexOf(filter.toLowerCase()) > -1)).map((language) => (
                    <MenuItem
                        text={language.name}
                        large
                        active={props.selected && props.selected.indexOf(language.shortcode) > -1}
                        onClick={() => {
                            props.onClick && props.onClick(language);
                        }}
                    />
                ))}
            </Menu>
        </>
    )

}